import axios from 'axios';
import { AxiosError } from 'axios';
import { deleteToken, deleteUser, persistToken, readUserToken } from '@app/services/localStorage.service';
import { refreshToken } from './auth.api';
import { globalNavigate } from '@app/controllers/navigationController';

export const httpApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});

httpApi.interceptors.request.use((config) => {
  const userToken = readUserToken();
  config.headers = { ...config.headers, 'x-access-token': `${userToken?.token}` };

  return config;
});

httpApi.interceptors.response.use(undefined, async (error: AxiosError) => {
  const originalConfig = error.config;
  let _retry = false;
  if (originalConfig.url !== '/apim/v1/authenticate' && error.response) {
    // Access Token was expired
    if (error.response.status === 401 && error.response.data.message.includes('Access Token was expired') && !_retry) {
      _retry = true;

      try {
        const userToken = readUserToken();
        await refreshToken()
          .then((rs) => {
            if (userToken) {
              userToken.token = rs.accessToken;
              persistToken(userToken);
            }
          })
          .catch(() => {
            globalNavigate('/auth/login');
          });

        return httpApi(originalConfig);
      } catch (_error) {
        return Promise.reject(_error);
      }
    } else if ([401, 403].includes(error.response.status)) {
      deleteToken();
      deleteUser();
      globalNavigate('/auth/login');
    }
  }
  return Promise.reject(error.response?.data.message);
});

export interface ApiErrorData {
  message: string;
}
